<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-table ref="table" pagination :max-items="itemsPerPage" :data="reporteCasosByProject">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between mb-10">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <div class="vx-col w-full">

            <!-- Compañía -->
            <vs-select v-model="casoCompaniaId" name="casoCompaniaId" label="Compañía" class="w-full mt-3 mb-3"
              @input="handleCompania" v-show="showSelects" placeholder="Seleccione la compañia">
              <!-- <vs-select-item value="" text="Seleccione la compañia" disabled />              -->
              <vs-select-item :key="item.id" :value="item.id" :text="item.id + ' - ' + item.descripcion"
                v-for="item in companiasList" />
            </vs-select>
            <span class="text-danger text-sm"
              v-show="errors.has('casoCompaniaId') || formerr.includes('casoCompaniaId')">Por favor
              seleccione la compañía</span>

            <!-- Proyecto -->
            <vs-select v-model="casoProyectoId" name="casoProyectoId" label="Proyecto" class="w-full mt-3 mb-3"
              @input="handleProyecto" v-show="showSelects" placeholder="Seleccione el proyecto">
              <!-- <vs-select-item value="" text="Seleccione el proyecto" disabled /> -->
              <vs-select-item :key="item.id" :value="item.id" :text="item.id + ' - ' + item.descripcion"
                v-for="item in proyectoList" />
            </vs-select>
            <span class="text-danger text-sm"
              v-show="errors.has('casoProyectoId') || formerr.includes('casoProyectoId')">Por favor seleccione el
              proyecto</span>

            <div class="w-full mt-4">
              <label for="case_state" class="vs-input--label text-primary">
                Estado de los casos
              </label>
              <vs-select v-model="case_state" name="case_state" class="w-full">
                <vs-select-item value="" text="Seleccione caso" disabled />
                <vs-select-item :key="item.value" :value="item.value" :text="item.text"
                  v-for="item in caseStatesOptions" />
              </vs-select>
              <span class="text-danger text-sm" v-show="errors.has('case_state') ||
                formerr.includes('case_state')
                ">Por favor seleccione el caso</span>
            </div>

            <div class="w-full mt-4">
              <label for="darequest_init_date" class="vs-input--label text-primary">
                Fecha inicial
              </label>
              <flat-pickr class="vs-inputx vs-input--input normal" id="darequest_init_date" :config="configdateIni"
                v-model="darequest_init_date" placeholder="dd/mm/aaaa" />
              <span class="text-danger text-sm" v-show="errors.has('darequest_init_date') ||
                formerr.includes('darequest_init_date')
                ">Por favor seleccione el dato</span>
            </div>

            <div class="w-full mt-4">
              <label for="darequest_end_date" class="vs-input--label text-primary">
                Fecha final
              </label>
              <flat-pickr class="vs-inputx vs-input--input normal" id="darequest_end_date" :config="configdateFin"
                v-model="darequest_end_date" placeholder="dd/mm/aaaa" />
              <span class="text-danger text-sm" v-show="errors.has('darequest_end_date') ||
                formerr.includes('darequest_end_date')
                ">Por favor seleccione el dato</span>
            </div>
            <!-- <div
              class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
              @click="addNewData"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Crear registro</span>
            </div> -->

            <div class="vx-col w-full flex justify-between mb-10" id="account-manage-buttons">
              <vs-button icon-pack="feather" icon="icon-search" class="mt-5"
                @click="actionSearchData()">Consultar</vs-button>

              <vs-button icon-pack="feather" icon="icon-download" class="mt-5"
                :disabled="this.lista_lb_tmp_excel.length === 0" @click="downloadExcel()"></vs-button>
            </div>
          </div>
        </div>
      </div>

      <template slot="thead">
        <vs-th :key="indexth" v-for="(row, indexth) in meta" :sort-key="row.sortKey" v-if="row">
          <p class="product-name font-medium truncate">{{ row.sortKey === 'vao' && casoCompaniaId !== 179 ? 'SUBPROYECTO' : row.title }}</p>
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :state="tr.estado == 1 ? 'success' : null" :data="tr" :key="indextr" v-for="(tr, indextr) in data"
            v-if="tr">
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.vaa }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.vao }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.vab }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.vac }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.vad }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.vae }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.vaao }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.vag }}
              </p>
            </vs-td>

            <vs-td>
              <p>
                {{ tr.vaaa }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.vah }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.vai }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.vaj }}
              </p>
            </vs-td>


            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.vaak }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.vaal }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.vak }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.val }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.van }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.vaq }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.vaam }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.vaan }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.vaai }}
              </p>
            </vs-td>

            <!-- <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="EyeIcon"
                svgClasses="w-5 h-5 hover:text-dark stroke-current"
                @click.stop="displayData(tr)"
              />
              <feather-icon
                icon="PlayIcon"
                svgClasses="w-5 h-5 hover:text-success stroke-current"
                class="ml-2"
                v-if="tr.estado != 1 && caseStates === 'Abiertos'"
              />
              <feather-icon
                icon="PauseIcon"
                svgClasses="w-5 h-5 hover:text-warning stroke-current"
                class="ml-2"
                v-if="tr.estado == 1 && caseStates === 'Abiertos'"
              />
              <feather-icon
                icon="SquareIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                v-if="caseStates === 'Abiertos'"
              />
            </vs-td> -->
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import CasoSidebar from '@/views/caso/CasoSidebar.vue'
import ListasModule from '@/store/listas-module/moduleDataList.js'
import ReportesModule from '@/store/reportes-module/moduleDataList.js'
import Datepicker from 'vuejs-datepicker'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Spanish as SpanishLocale } from 'flatpickr/dist/l10n/es.js'
import XLSX from 'xlsx'
import { companies, companiesEnums, searchCompany, searchCompanyById } from '../../config/companies.js'
// import validateConfigData from '../../../helpers/validateConfigData'

export default {
  components: {
    CasoSidebar,
    Datepicker,
    flatPickr
  },
  created() {

    this.initListOfValues()
    // Loading
    if (!ReportesModule.isRegistered) {
      this.$store.registerModule('ReportesModule', ReportesModule)
      ReportesModule.isRegistered = true
    }

    this.company = searchCompany(this.$route.params.nameCompany)
  },
  mounted() {
    this.isMounted = true
  },
  data() {
    return {

      company: null,
      showSelects: false,
      selectedCompany: "",
      case_state: '',
      caseStatesOptions: [
        { value: 'ABIERTOS', text: 'Casos Abiertos' },
        { value: 'CERRADOS', text: 'Casos Cerrados' },
        { value: 'TODOS', text: 'Casos abiertos y cerrados' }
      ],
      casoCompaniaId: '',
      casoProyectoId: '',
      selected: [],
      itemsPerPage: 4,
      isMounted: false,
      indexDelete: '',
      caseStates: 'ABIERTOS',
      lista_lb_tmp_filter: [],
      lista_lb_tmp_excel: [],



      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      sidebarViewMode: true,

      formerr: [], // Crear => true/Modificar => false,
      darequest_init_date: null,
      darequest_end_date: null,

      configdateIni: {
        dateFormat: 'd/m/Y',
        locale: SpanishLocale,
        //enableTime: true,
        //enableSeconds: true,
        maxDate: null
      },
      configdateFin: {
        dateFormat: 'd/m/Y',
        locale: SpanishLocale,
        //enableTime: true,
        //enableSeconds: true,
        minDate: null
      }
    }
  },
  computed: {

    companiasList() {
      return this.$store.state.ListasModule.companies
    },
    proyectoList() {
      return this.$store.state.ListasModule.proyecto
    },
    validateForm() {
      return !this.errors.any() && this.formerr.length <= 0
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    reporteCasosByProject() {
      return this.$store.state.ReportesModule.reporteCasosByProject
    },
    meta() {
      return this.$store.state.ReportesModule.meta
    }
  },
  methods: {


    initListOfValues() {
      //Validar que la compañia del usuario sea Arquitecsoft
      this.selectedCompany = this.$route.params.nameCompany
      if (this.selectedCompany === 'arquitecsoft') {
        //Mostrara dos imput adicionales
        this.showSelects = true
      } else {
        this.showSelects = false
      }
      if (!ListasModule.isRegistered) {
        this.$store.registerModule('ListasModule', ListasModule)
        ListasModule.isRegistered = true
      }

      //this.casoCompaniaId = searchCompany(this.$route.params.nameCompany).idCompany

      this.$vs.loading()
      this.$store
        .dispatch('ListasModule/getCompanias', { ...this.company, idUser: this.$store.state.auth.userDetails().id })
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })

      this.getAllProyecto()
    },

    handleProyecto(item) {

      this.clearAllList()

      if (item) {
        const companyTemp = this.company
        companyTemp.idProject = item
        //console.log('companyTemp', companyTemp)

      }
    },

    handleCompania(item) {
      this.company = searchCompanyById(item)
      this.getAllProyecto()
    },

    getAllProyecto() {

      // Eliminamos la lista de datos de los proyectos
      this.casoProyectoId = null

      this.$store.dispatch('ReportesModule/clearAllReporte')

      // Eliminamos la lista de todos los demás datos
      this.clearAllList()

      this.$vs.loading()
      this.$store
        .dispatch('ListasModule/getAllProyecto', { ...this.company, idUser: this.$store.state.auth.userDetails().id })
        .then((response) => {
          this.$vs.loading.close()

          if (response.data) {
            const list = response.data.listaProyecto
            if (list) {
              if (list.length === 1) {
                const id = list[0].id
                this.casoProyectoId = id

                this.handleProyecto(id)
              }
            }
          }
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },

    clearAllList() {

      this.casoSubProyectoId = null
      this.casoItilIncidentTypeId = null
      this.casoFuenteId = null
      this.casoTipoActividadExternaId = null
      this.casoPrioridadId = null
      this.casoCriticalityId = null
      this.casoServicioId = null
      this.casoGrupoTipoActividadId = null
      this.casoTipoActividadId = null
      this.casoAplicativoId = null
      this.casoHelpDesk = null
      this.casoUsuarioAtiendeId = null
      this.casoClaseCasoId = null
      this.casoAreaId = null


      this.$store.dispatch('ResportesModule/clearAllReporte')
      this.$store.dispatch('ListasModule/clearAllSubProyecto')
      this.$store.dispatch('ListasModule/clearAllItilIncidentType')
      this.$store.dispatch('ListasModule/clearAllSourceRequest')
      this.$store.dispatch('ListasModule/clearAllTipoActividadExterna')
      this.$store.dispatch('ListasModule/clearAllCriticality')
      this.$store.dispatch('ListasModule/clearAllServicios')
      this.$store.dispatch('ListasModule/clearAllGrupoTipoActividad')
      this.$store.dispatch('ListasModule/clearAllTipoActividad')
      this.$store.dispatch('ListasModule/clearAllApplicative')
      this.$store.dispatch('ListasModule/clearAllHelpDesk')
      this.$store.dispatch('ListasModule/clearAllRequestClass')
      this.$store.dispatch('ListasModule/clearAllAreaByResource')
      this.$store.dispatch('ListasModule/clearAllProjectAddData')
      this.$store.dispatch('ListasModule/clearAllProjectIdAddData')
    },
    addNewData() {
      this.sidebarData = {}
      this.sidebarViewMode = false
      this.toggleDataSidebar(true)
    },
    actionSearchData() {
      this.formerr = []

      console.log('this.darequest_init_date', this.darequest_init_date)
      console.log('darequest_end_date', this.darequest_end_date)
      console.log('caseStates', this.case_state)
      console.log('casoCompaniaId', this.casoCompaniaId)
      console.log('casoProyectoId', this.casoProyectoId)

      if (this.case_state === null ||
        this.case_state === undefined ||
        this.case_state === '') {
        this.formerr.push('case_state')
      }
      if (this.showSelects) {
        if (this.casoCompaniaId === null ||
          this.casoCompaniaId === undefined ||
          this.casoCompaniaId === '') {
          this.formerr.push('casoCompaniaId')
        }
      }
      if (this.showSelects) {
        if (this.casoProyectoId === null ||
          this.casoProyectoId === undefined ||
          this.casoProyectoId === '') {
          this.formerr.push('casoProyectoId')
        }
      }
      if (
        this.darequest_init_date === null ||
        this.darequest_init_date === undefined ||
        this.darequest_init_date === ''
      ) {
        this.formerr.push('darequest_init_date')
      }
      if (
        this.darequest_end_date === null ||
        this.darequest_end_date === undefined ||
        this.darequest_end_date === ''
      ) {
        this.formerr.push('darequest_end_date')
      }

      if (this.validateForm) {
        const data = {
          idUser: this.$store.state.auth.userDetails().id,
          sbFechaIni: this.darequest_init_date,
          sbFechaFin: this.darequest_end_date,
          idProject: this.company.idProject,
          sbEstado: this.case_state
        }

        console.log('data, ', data)
        this.searchData(data)
      }
    },
    searchData(param) {
      this.lista_lb_tmp_filter = []


      //TODO apuntar a
      this.$vs.loading()

      this.$store.dispatch('ReportesModule/getReporteCasoByStatusByProject', param)
        //this.$store.dispatch(this.case_state === 'Cerrados' ? 'ReportesModule/getReporteCasoCerradosByProject' : 'ReportesModule/getReporteCasoAbiertosByProject', param)

        // this.$store.dispatch(this.case_state === 'Abiertos'?"ReportesModule/get")
        .then((response) => {
          this.$vs.loading.close()

          if (response.data.length > 0) {

            response.data.find((legalBasisTmp) => {
              this.lista_lb_tmp_filter.push(legalBasisTmp)
            })

            if (this.lista_lb_tmp_filter.length > 0) {
              this.lista_lb_tmp_excel = []

              this.lista_lb_tmp_filter.forEach((element) => {
                let tmp_excel = {
                  PROYECTO: element.vaa
                }

                if (this.casoCompaniaId === 179) {
                  tmp_excel.DISTRIBUIDORA = element.vao
                } else {
                  tmp_excel.SUBPROYECTO = element.vao
                }

                tmp_excel = {
                  ...tmp_excel,
                  NUM_CASO: element.vab,
                  DESC_CASO: element.vac,
                  RESPONSABLE: element.vad,
                  REGISTRA: element.vae,
                  GRUPO_TIPO_CASO: element.vaao,
                  TIPO_CASO: element.vag,
                  APLICATIVO: element.vaaa,
                  NIVEL: element.vah,
                  ESTADO: element.vai,
                  FECHA_REGISTRO: element.vaj,
                  AÑO: element.vaak,
                  MES: element.vaal,
                  FECHA_CIERRE: element.vak,
                  FECHA_COMPROMISO: element.val,
                  OBSERVACION: element.van
                }

                tmp_excel.VENCIDO = element.vaq
                tmp_excel.CODIGO_CASO_EXTERNO = element.vaam
                tmp_excel.CUENTA = element.vaan
                tmp_excel.FUENTE = element.vaai

                this.lista_lb_tmp_excel.push(tmp_excel)

              })
            }
          } else {
            this.lista_lb_tmp_filter = []
            this.lista_lb_tmp_excel = []

            console.log('aviso', 'entro a lista vacia')
            this.$vs.dialog({
              color: 'warning',
              title: 'Aviso',
              text: 'No se encontraron datos para esta consulta.',
              acceptText: 'Aceptar'
            })

          }

          //console.log('Lista filtrada, ', this.lista_lb_tmp_filter)

        })
        .catch((error) => {
          console.log('error report list', error)
          this.$vs.loading.close()

          this.$vs.dialog({
            color: 'danger',
            title: 'Error',
            text: 'No se pudo realizar la conexión, inténtelo de nuevo más tarde.',
            acceptText: 'Aceptar'
          })
        })
    },
    downloadExcel() {
      // console.log(JSON.stringify(this.lista_lb_tmp_excel))

      if (this.lista_lb_tmp_excel.length > 0) {
        const data = XLSX.utils.json_to_sheet(this.lista_lb_tmp_excel)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, data, 'data')
        XLSX.writeFile(wb, 'reporte.xlsx')
      } else {
        this.$vs.dialog({
          color: 'warning',
          title: 'Aviso',
          text: 'No hay datos para descargar.',
          acceptText: 'Aceptar'
        })
      }
    },
    displayData(data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.sidebarViewMode = true
      this.toggleDataSidebar(true)
    },
    getOrderStatusColor(status) {
      if (status === 'on_hold') return 'warning'
      if (status === 'delivered') return 'success'
      if (status === 'canceled') return 'danger'
      return 'primary'
    },
    getPopularityColor(num) {
      if (num > 90) return 'success'
      if (num > 70) return 'primary'
      if (num >= 50) return 'warning'
      if (num < 50) return 'danger'
      return 'primary'
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
              Below media-queries is fix for responsiveness of action buttons
              Note: If you change action buttons or layout of this page, Please remove below style
            */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
